"use client";

import { useEffect } from "react";

const STORAGE_KEY = "ai_comic_uid";
const COOKIE_NAME = "ai_comic_uid";

export function UserIdSync({ userId }: { userId: string }) {
  useEffect(() => {
    if (!userId) return;
    localStorage.setItem(STORAGE_KEY, userId);
    document.cookie = `${COOKIE_NAME}=${userId}; path=/; max-age=31536000; samesite=lax`;
  }, [userId]);

  return null;
}
